import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';

import { messages } from './messages';

import styles from './trial-upsell-footer.module.less';

type TrialUpsellFooterProps = {
  onUpgradeNow: () => void;
  onStartTrial: () => void;
  isLoading?: boolean;
};

export const TrialUpsellFooter = ({ onUpgradeNow, onStartTrial, isLoading = false }: TrialUpsellFooterProps) => {
  return (
    <div>
      <Button className={styles['upgrade-button']} onClick={onUpgradeNow} theme='upsell'>
        <FormattedMessage {...messages.upgradeSubscription} />
      </Button>
      <Button className={styles['free-trial-button']} disabled={isLoading} onClick={onStartTrial} theme='link'>
        <FormattedMessage {...messages.startFreeTrial} />
      </Button>
    </div>
  );
};
